import type { Announcement, DesignSystem, Maintenance, MobileReleaseChannelReport, MobileReleaseControl, OtaChannelName } from '@repo/types';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';

/** Annonces (bandeaux) et mode maintenance. */
export class PlatformService {
  /** État public (sans connexion) : utilisé par la page de maintenance. */
  async getStatus(): Promise<{ maintenance: Maintenance; designSystem?: DesignSystem }> {
    const { data } = await axiosInstance.get<{ data: { maintenance: Maintenance; designSystem?: DesignSystem } }>(ENDPOINTS.PLATFORM.STATUS);
    return data.data;
  }

  async getMyAnnouncements(): Promise<Announcement[]> {
    const { data } = await axiosInstance.get<{ data: Announcement[] }>(ENDPOINTS.PLATFORM.MY_ANNOUNCEMENTS);
    return data.data ?? [];
  }

  async getAnnouncements(): Promise<Announcement[]> {
    const { data } = await axiosInstance.get<{ data: Announcement[] }>(ENDPOINTS.SUPERADMIN.ANNOUNCEMENTS);
    return data.data ?? [];
  }

  async updateAnnouncements(announcements: Announcement[]): Promise<Announcement[]> {
    const { data } = await axiosInstance.put<{ data: Announcement[] }>(ENDPOINTS.SUPERADMIN.ANNOUNCEMENTS, announcements);
    return data.data;
  }

  async getMaintenance(): Promise<Maintenance> {
    const { data } = await axiosInstance.get<{ data: Maintenance }>(ENDPOINTS.SUPERADMIN.MAINTENANCE);
    return data.data;
  }

  /** Versions de l'app mobile par canal OTA (espace /superadmin). */
  async getMobileReleases(): Promise<MobileReleaseChannelReport[]> {
    const { data } = await axiosInstance.get<{ data: MobileReleaseChannelReport[] }>(ENDPOINTS.SUPERADMIN.MOBILE_RELEASES);
    return data.data;
  }

  async updateMobileRelease(channel: OtaChannelName, control: MobileReleaseControl): Promise<MobileReleaseChannelReport[]> {
    const { data } = await axiosInstance.put<{ data: MobileReleaseChannelReport[] }>(ENDPOINTS.SUPERADMIN.MOBILE_RELEASE(channel), control);
    return data.data;
  }

  async getDesignSystem(): Promise<DesignSystem> {
    const { data } = await axiosInstance.get<{ data: { design_system: DesignSystem } }>(ENDPOINTS.SUPERADMIN.DESIGN_SYSTEM);
    return data.data.design_system;
  }

  async updateDesignSystem(designSystem: DesignSystem): Promise<DesignSystem> {
    const { data } = await axiosInstance.put<{ data: { design_system: DesignSystem } }>(ENDPOINTS.SUPERADMIN.DESIGN_SYSTEM, { design_system: designSystem });
    return data.data.design_system;
  }

  async updateMaintenance(maintenance: Maintenance): Promise<Maintenance> {
    const { data } = await axiosInstance.put<{ data: Maintenance }>(ENDPOINTS.SUPERADMIN.MAINTENANCE, maintenance);
    return data.data;
  }
}

export const platformService = new PlatformService();
